import React from 'react';
import { Form, Label, Input, FormFeedback, Button, Spinner, Alert } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../hooks/use-login';

export const LoginForm = () => {
    const navigate = useNavigate();
    const { validation, error, loading, passwordShow, togglePasswordVisibility } = useLogin(navigate);

    return (
        <React.Fragment>
            {error ? (<Alert color="danger" className="mb-4">{error}</Alert>) : null}

            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3">
                    <Label htmlFor="document" className="form-label"> Documento de identidad <span className="text-danger">*</span>
                    </Label>
                    <Input
                        id="document"
                        name="document"
                        className="form-control"
                        placeholder="Ingrese su documento de identidad"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.document || ""}
                        invalid={!!(validation.touched.document && validation.errors.document)}
                        aria-invalid={!!(validation.touched.document && validation.errors.document)}
                        aria-describedby="document-error"
                        disabled={loading}
                    />
                    {validation.touched.document && validation.errors.document ? (
                        <FormFeedback type="invalid" id="document-error">
                            {validation.errors.document as string}
                        </FormFeedback>
                    ) : null}
                </div>

                <div className="mb-3">
                    {/*
                    <div className="float-end">
                        <Link to="/forgot-password" className="text-muted">¿Has olvidado tu contraseña?</Link>
                    </div>
                    */}
                    <Label htmlFor="password-input" className="form-label">
                        Contraseña <span className="text-danger">*</span>
                    </Label>
                    <div className="position-relative auth-pass-inputgroup mb-3">
                        <Input
                            id="password-input"
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordShow ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder="Introducir la contraseña"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={!!(validation.touched.password && validation.errors.password)}
                            aria-invalid={!!(validation.touched.password && validation.errors.password)}
                            aria-describedby="password-error"
                            disabled={loading}
                        />
                        {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid" id="password-error">
                                {validation.errors.password as string}
                            </FormFeedback>
                        ) : null}
                        <button
                            className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                            type="button"
                            id="password-addon"
                            onClick={togglePasswordVisibility}
                            disabled={loading}
                            aria-label={passwordShow ? "Ocultar contraseña" : "Mostrar contraseña"}
                        >
                            <i className={passwordShow ? "ri-eye-off-fill align-middle" : "ri-eye-fill align-middle"}></i>
                        </button>
                    </div>
                </div>

                <div className="mt-4">
                    <Button
                        color="success"
                        disabled={loading}
                        className="btn btn-success w-100"
                        type="submit"
                    >
                        {loading && <Spinner size="sm" className="me-2">Cargando...</Spinner>}
                        Iniciar sesión
                    </Button>
                </div>
            </Form>
        </React.Fragment>
    );
};
